import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import InstructorLibraryTable from "./InstructorLibraryTable";
import { foodLibraryService } from "./services/FoodLibrary.service";
import ConfirmationModal from "../../Shared/ConfirmationModal";

class InstructorManagedFoodLibrary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            pageNum: 0,
            pageSize: 10,
            pages: null,
            filterParams: null,
            fetching: false,
            data: null,
            submitted: false,
            selectedRow: null,
            hasParams: false,
            viewFood: false,
            editmode: false,
            submitting: false,
            formResponse: null,
            formError: null,
            action: null,
            showModal: false,
        };
    }

    componentDidMount() {
        const { pageNum, pageSize } = this.state;
        this.getAllFoodItems({ "page-num": pageNum + 1, "page-size": pageSize });
    }
    getAllFoodItems = (params) => {
        this.setState({ fetching: true });
        foodLibraryService
            .getAllFoodItems(params)
            .then((response) => {
                response &&
                    this.setState({
                        data: response,
                        pages: Math.ceil(response.count / params["page-size"]),
                        error: null,
                        fetching: false,
                    });
            })
            .catch((error) => this.setState({ error, fetching: false }));
    };
    addFoodLibrary = async (data) => {
        const { pageSize, selectedRow } = this.state;
        this.setState({
            ...this.state,
            submitting: true,
            submitted: false,
            formResponse: null,
            formError: null,
        });

        try {
            let response = await foodLibraryService.addFoodLibrary(data);
            if (response) {
                if (!selectedRow) {
                    toast.success("Food item created successfully", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 4000,
                    });
                }
                this.setState({ submitted: true });
                //this.reset();
                this.getAllFoodItems({ "page-num": 1, "page-size": pageSize });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                submitting: false,
            });
        }
    };

    updateFoodLibrary = async (data) => {
        const { pageSize, selectedRow } = this.state;
        this.setState({
            ...this.state,
            submitting: true,
            submitted: false,
            formResponse: null,
            formError: null,
        });

        try {
            let response = await foodLibraryService.updateFoodLibrary(data, selectedRow && selectedRow.id);
            if (response) {
                toast.success("Food item updated successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.reset();
                //update table...
                this.getAllFoodItems({ "page-num": 1, "page-size": pageSize });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                submitting: false,
            });
        }
    };

    deleteFoodItem = async () => {
        const { pageSize, selectedRow } = this.state;
        try {
            let response = await foodLibraryService.deleteFoodItem(selectedRow && selectedRow.id);
            if (response == null) {
                toast.success("Food item deleted successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.reset();
                //update table...
                this.getAllFoodItems({ "page-num": 1, "page-size": pageSize });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                submitting: false,
                showModal: !this.state.showModal,
            });
        }
    };

    handleSubmit = (data) => {
        if (this.state.editmode) {
            this.updateFoodLibrary(data);
        } else {
            this.addFoodLibrary(data);
        }
    };

    reset = () => {
        this.setState({ submitted: false, selectedRow: null, hasParams: false, viewFood: false, submitting: false, editmode: false, showModal: false });
    };

    ViewFoodLibrarySelectRow = (selectedRow) => {
        this.setState({
            selectedRow: selectedRow.original,
            hasParams: true,
            viewFood: true,
            showInterests: true,
            editmode: false,
        });
    };

    editFoodItems = (selectedRow) => {
        this.setState({
            selectedRow: selectedRow.original,
            hasParams: true,
            viewFood: false,
            showInterests: false,
            editmode: true,
        });
    };

    fetchData = () => {
        const { pageNum, pageSize, filterParams } = this.state;
        let params = { "page-num": pageNum + 1, "page-size": pageSize };
        if (filterParams) {
            params = { ...filterParams, ...params };
        }
        //get all food items...
        this.getAllFoodItems(params);
    };

    setPageNumber = (pageIndex) => {
        this.setState({ pageNum: pageIndex }, () => this.fetchData());
    };

    setPageSize = (pageSize, pageIndex) => {
        this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
    };

    filterData = (params) => {
        this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
    };

    showConfirmation = (selectedRow) => {
        this.setState({
            selectedRow: selectedRow.original,
            showModal: !this.state.showModal,
        });
    };

    render() {
        const { selectedRow, hasParams,  pages, pageNum, pageSize, fetching, data, error,  } = this.state;
        return (
            <Row>
              
                <Col sm="12">
                    <InstructorLibraryTable
                        viewFoodsLibrary={this.ViewFoodLibrarySelectRow}
                        fetching={fetching}
                        hasParams={hasParams}
                        selectedRow={selectedRow}
                        data={data}
                        pages={pages}
                        page={pageNum}
                        pageSize={pageSize}
                        error={error}
                        filterData={this.filterData}
                        setPageNumber={this.setPageNumber}
                        setPageSize={this.setPageSize}
                        selectRow={this.editFoodItems}
                        showModal={this.showConfirmation}
                    />
                </Col>
                <ConfirmationModal isOpen={this.state.showModal} showModal={this.showConfirmation} action={this.deleteFoodItem} item={selectedRow} />
            </Row>
        );
    }
}

export default InstructorManagedFoodLibrary;
